import { PaginatedResponse, useApi } from '@/api';
import { CardList, LinkButton, Link, ListSkeleton } from '@/components';
import {
  Flex,
  WalletAddress,
  CurrencyValue,
  ListItem
} from '@blockanalitica/ui';

type WalletsData = {
  wallet_address: string;
  market_underlying_address: string;
  market_symbol: string;
  supply: string | null;
};

export default function TopSuppliers({
  marketAddress,
  network,
  ...rest
}: {
  marketAddress: string;
  network: string;
}) {
  const [data, error] = useApi<PaginatedResponse<WalletsData[]>>({
    url: `/markets/${marketAddress}/wallets/`,
    queryParams: {
      type: 'supplier',
      limit: '5',
      sort: '-supply'
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ListSkeleton />;
  }

  return (
    <CardList
      title="Top Suppliers"
      action={
        <LinkButton to="suppliers" variant="secondary">
          view all
        </LinkButton>
      }
      {...rest}>
      {data['results'].length > 0 &&
        data['results'].map((row) => (
          <ListItem
            // @ts-ignore
            as={Link}
            key={row.wallet_address}
            to={`./suppliers/${row.wallet_address}`}
            relative="path">
            <Flex justifyContent="space-between">
              <WalletAddress address={row.wallet_address} />

              <CurrencyValue
                value={row.supply}
                options={{
                  currency: {
                    name: row.market_symbol,
                    address: row.market_underlying_address,
                    network: network
                  }
                }}
              />
            </Flex>
          </ListItem>
        ))}
    </CardList>
  );
}
